import React from 'react';

const now = new Date().getFullYear();

const footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <div className="aside"></div>
        <div className="copyright">
          <span>Copyright ©</span> <span>2016 - {now}</span>
        </div>
        <a className="aside logo" href="https://qulto.eu" target="_blank" rel="noreferrer">
          <img src={`${process.env.PUBLIC_URL}/logos/qulto_logo.png`} alt="Qulto Logo" />
        </a>
      </div>
    </footer>
  );
};

export default footer;
